export default __webpack_public_path__ + "static/media/Shot_7.0000.f078b1cb.png";